import { render, staticRenderFns } from "./cart-payment-methods.vue?vue&type=template&id=c74e5078&"
import script from "./cart-payment-methods.vue?vue&type=script&lang=js&"
export * from "./cart-payment-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports